import React from "react"

import i18n from "./config/i18n"
import { Layout } from "./src/components/layout/Layout"
import GlobalSearchProvider from "./src/contexts/GlobalSearchProvider"
import { HeaderProvider } from "./src/contexts/HeaderContext"
import LangContext from "./src/contexts/LangContext"
import LocationContext from "./src/contexts/LocationContext"
import MainMenuProvider from "./src/contexts/MainMenuProvider"

const wrapPageElement = ({ element, props }) => {
  const {
    pageContext: { locale },
  } = props
  return (
    <LangContext.Provider value={{ locale, i18n }}>
      <LocationContext.Provider value={props.location}>
        <MainMenuProvider>
          <GlobalSearchProvider>
            <HeaderProvider>
              <Layout {...props}>{element}</Layout>
            </HeaderProvider>
          </GlobalSearchProvider>
        </MainMenuProvider>
      </LocationContext.Provider>
    </LangContext.Provider>
  )
}

export default wrapPageElement
